let code
let scanSuccessDelegate
let scanCancelDelegate
let silenceTimer = null

const SILENCE_TIMEOUT_MS = 250

export const startScan = (onScanSuccess, onScanCancel) => {
  clearCode()
  clearSilenceTimer()
  scanSuccessDelegate = onScanSuccess
  scanCancelDelegate = onScanCancel
  document.addEventListener('keydown', scanListener)
}

export const stopScan = () => {
  clearSilenceTimer()
  document.removeEventListener('keydown', scanListener)
}

const scanListener = (keyboardEvent) => {
  if (keyboardEvent.key === 'Escape' || keyboardEvent.key === 'ESC') {
    scanWillCancel()
  } else if (keyboardEvent.key === 'Enter') {
    resetSilenceTimer()
  } else if (keyboardEvent.key) {
    appendKey(keyboardEvent.key)
    resetSilenceTimer()
  }
}

const appendKey = (key) => {
  if (key.length === 1) code += key
}

const resetSilenceTimer = () => {
  clearSilenceTimer()
  silenceTimer = setTimeout(() => {
    silenceTimer = null
    const scannedCode = code.trim()
    clearCode()
    if (scannedCode.length > 0) {
      if (scanSuccessDelegate) scanSuccessDelegate(scannedCode)
    }
  }, SILENCE_TIMEOUT_MS)
}

const clearSilenceTimer = () => {
  if (silenceTimer !== null) {
    clearTimeout(silenceTimer)
    silenceTimer = null
  }
}

const scanWillCancel = () => {
  stopScan()
  clearCode()
  if (scanCancelDelegate) scanCancelDelegate()
}

export const getCode = () => code || undefined

export const clearCode = () => {
  code = ''
}

clearCode()
